const apiUrl = process.env.REACT_APP_API_URL;
export const PostInscripcioIdAlumneId = async (id_inscripcio: string, id_alumne : string, page: string, inscripcio: any) => {
    try {
        const response = await fetch(`${apiUrl}:8071/inscripcions/${id_inscripcio}/alumne/${id_alumne}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify(inscripcio)
        });
        if (response.ok) {
            const jsonData = await response.json();
            return jsonData;
        } else {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
